import * as React from 'react'
import {unzip} from "../utils";
import {ReactChild} from "react";

export type TabsProps<Tab extends string> = {
	active: Tab
	onActivate: (a: Tab) => void
	children?: (boolean | JSX.Element)[] // behavior is undefined when children aren't panels.
}

export type PanelProps<Tab extends string> = {
	name: string
	id: Tab
	children?: React.ReactNode
}

export const Panel = <Tab extends string>(props: PanelProps<Tab>) => <div>{props.children}</div>

export const Tabs = <Tab extends string>(props: TabsProps<Tab>) => {
	const children = React.Children.toArray(props.children)
	const mapped = children.map((child:ReactChild): [JSX.Element|false, JSX.Element] => {
			if (typeof child !== "string" && typeof child !== "number") {
				if (child.type != Panel)
					throw new Error('Tabs was expecting a Panel, but got something else.')

				const isActive = props.active == child.props.id
				const classNames = ["ui-state-default", "ui-corner-top"].concat(
					isActive ? ["ui-tabs-active", "ui-state-active"] : []
				).join(" ")
				return [
					isActive &&
					<div key={`tab-${child.props.id}`} className="ui-tabs-panel ui-widget-content ui-corner-bottom" role="tabpanel">
						{child}
					</div>,
					<li key={`panel-${child.props.id}`} className={classNames}>
						<a onClick={() => props.onActivate(child.props.id)} className="ui-tabs-anchor">{child.props.name}</a>
					</li>
				]
			}
			throw new Error('Tabs was expecting a Panel, but got something else.')
		}
	)

	const [panels, tabs] = unzip(mapped)

	return <div className="ui-tabs ui-widget ui-widget-content ui-corner-all">
		<ul className="ui-tabs-nav ui-helper-reset ui-helper-clearfix ui-widget-header ui-corner-all" role="tablist">
			{tabs}
		</ul>
		{panels}
	</div>
}



// WEBPACK FOOTER //
// ./src/lib/sbhtml/tabs.tsx